<div class="grid">
  <div class="col-12 md:col-6">
    <label class="grey-text">Magazzino di partenza</label>
    <p class="mt-1 mb-0 font-bold">{{ sourceWarehouse.name }}</p>
  </div>

  <div class="col-12 md:col-6">
    <label class="grey-text">Magazzino di destinazione</label>
    <div class="flex align-items-center mt-1">
      <p class="mb-0 mr-3 font-bold">{{ destination?.name || '-' }}</p>
      <p-button
        type="button"
        [label]="destination ? 'Cambia' : 'Scegli magazzino'"
        icon="pi pi-search"
        styleClass="butt"
        [rounded]="true"
        [disabled]="isSubmitting"
        (click)="openDestinationPicker()"></p-button>
    </div>
    <small
      class="p-error"
      *ngIf="destination && destinationError"
      >{{ destinationError }}</small
    >
  </div>

  <div class="col-12">
    <label class="grey-text">Note</label>
    <textarea
      pInputTextarea
      class="w-full"
      rows="2"
      [formControl]="notes"></textarea>
  </div>

  <div class="col-12">
    <small
      class="grey-text block mb-1"
      *ngIf="ticketId">
      I prodotti trasferiti passano alla commessa del ticket.
    </small>
    <small
      class="grey-text"
      *ngIf="groups.length > 1">
      I prodotti vengono trasferiti con {{ groups.length }} movimenti separati, uno per ogni
      utilizzo e commessa.
    </small>
  </div>

  <div
    class="col-12"
    *ngFor="let g of groups">
    <h4 class="mb-2">{{ g.label }}</h4>
    <div
      class="transfer-row"
      *ngFor="let r of g.rows">
      <div class="grid align-items-start">
        <div class="col-12 md:col-6">
          <p class="font-bold mb-0">{{ r.name }}</p>
          <small class="grey-text">{{ r.brand }}</small>
          <small class="grey-text block">In giacenza: {{ r.stock_qty }}</small>
          <small
            class="p-error block"
            *ngIf="rowError(r) as err"
            >{{ err }}</small
          >
        </div>

        <div class="col-10 md:col-5">
          <ng-container *ngIf="!r.serialized">
            <label class="grey-text">Quantità</label>
            <input
              type="number"
              pInputText
              class="w-full"
              [min]="1"
              [max]="r.stock_qty"
              [formControl]="r.qtyControl" />
          </ng-container>

          <ng-container *ngIf="r.serialized">
            <label class="grey-text">Seriali ({{ r.serials.length }})</label>
            <div
              class="flex"
              *ngIf="!r.fixed_serials">
              <p-autoComplete
                class="flex-grow-1"
                styleClass="w-full"
                inputStyleClass="w-full"
                [formControl]="r.tmpSerial"
                [suggestions]="r.suggestedSerials"
                field="serial_number"
                placeholder="Cerca o digita il seriale"
                appendTo="body"
                (completeMethod)="filterSerials($event, r)"
                (onSelect)="addSerial(r)"
                (keydown)="addSerialKeyDown($any($event), r)"></p-autoComplete>
              <button
                pButton
                type="button"
                icon="pi pi-plus"
                class="ml-2"
                [disabled]="!r.tmpSerial.value"
                (click)="addSerial(r)"></button>
            </div>
            <div class="mt-2">
              <p-chip
                *ngFor="let s of r.serials; let i = index"
                class="mr-1 mb-1"
                [label]="s.code + (s.in_stock ? '' : ' (nuovo)')"
                [removable]="!r.fixed_serials"
                (onRemove)="removeSerial(r, i)"></p-chip>
            </div>
          </ng-container>
        </div>

        <div class="col-2 md:col-1 text-right">
          <p-button
            type="button"
            icon="pi pi-trash"
            styleClass="butt red"
            [rounded]="true"
            [disabled]="isSubmitting || !!r.fixed_serials"
            pTooltip="Rimuovi dal trasferimento"
            tooltipPosition="left"
            (click)="removeRow(g, r)"></p-button>
        </div>
      </div>
      <hr class="my-2" />
    </div>
  </div>

  <div
    class="col-12"
    *ngIf="ambiguousItems.length > 0">
    <h4 class="mb-2">Prodotto sulla commessa di destinazione</h4>
    <p class="grey-text mb-3">
      Uno o più prodotti hanno più prodotti di commessa disponibili sulla commessa di destinazione:
      scegli a quale attribuire il trasferimento per ciascun prodotto.
    </p>
    <div
      *ngFor="let item of ambiguousItems"
      class="field grid align-items-center">
      <label class="col-12 md:col-4">{{ item.product_name ?? 'Prodotto ' + item.product_id }}</label>
      <div class="col-12 md:col-8">
        <p-dropdown
          [options]="item.candidates"
          [(ngModel)]="item.selected"
          optionLabel="agreement_code"
          optionValue="id"
          placeholder="Scegli il prodotto da usare..."
          styleClass="w-full"
          appendTo="body">
          <ng-template
            let-candidate
            pTemplate="item">
            {{ candidate.name ?? candidate.agreement_code }}
            <ng-container *ngIf="candidate.part_number"> - {{ candidate.part_number }}</ng-container>
            <ng-container *ngIf="candidate.code_internal"> ({{ candidate.code_internal }})</ng-container>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
  </div>

  <div
    class="col-12"
    *ngIf="groups.length === 0">
    <p class="grey-text">Nessun prodotto da trasferire.</p>
  </div>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      icon="pi pi-times"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"
      [disabled]="isSubmitting"></p-button>
    <p-button
      type="button"
      label="Trasferisci"
      icon="pi pi-check"
      (click)="confirm()"
      styleClass="butt"
      [rounded]="true"
      [loading]="isSubmitting"
      [disabled]="!canSubmit"></p-button>
  </div>
</div>
